module.exports = __webpack_public_path__ + "img/rank-card-bg.82fd7595.svg";